module.exports = __webpack_public_path__ + "img/opp5.f2d61a3f.png";